/**
 * Read more on click
 *
 * @param {string} selectorToggle - selector for readmore toggle
 */

export const readMore = (selectorToggle = '.ghwp-testimonial-quote-show') => {
    const readMoreElements = document.querySelectorAll(selectorToggle);

    if (readMoreElements.length === 0) {
        return;
    }

    Array.prototype.forEach.call(readMoreElements, readMoreThis => {
        let toggle = readMoreThis;
        let panel = toggle.nextElementSibling;

        toggle.onclick = () => {
            let expanded = toggle.getAttribute('aria-expanded') === 'true';
            toggle.setAttribute('aria-expanded', !expanded);
            panel.setAttribute('aria-hidden', expanded);
            panel.classList.toggle('is-open');
        };
    });
};
